import {useTranslation, TKey} from '@/translations/i18n.tsx'
import {AssignmentScheduledDate} from '@features/assignment/components/assignment-scheduled-date'
import {FC} from 'react'
import {Assignment, ServiceType} from '@features/assignment/types'
import {ThreeDScanCard} from '@features/assignment/components/three-d-scan-card'
import {envVars} from '@/envVars.ts'
import {
    ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME
} from '@features/assignment/constants'

interface ScheduledDescriptionProps {
    assignment: Assignment
    serviceType: ServiceType
}

export const ScheduledDescription: FC<ScheduledDescriptionProps> = ({assignment, serviceType}) => {
    const {t} = useTranslation()

    return (
        <div className="flex flex-col gap-6 w-full">
            <div className={ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME}>
                <div className={ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME}>
                    <h3 className={ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME}>
                        {t('assignment:descriptions:scheduled:title')}
                    </h3>
                    {serviceType != 'review' && (
                        <p className={ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME}>
                            {t(`assignment:descriptions:scheduled:paragraph:${serviceType}` as TKey)}
                        </p>
                    )}
                </div>
                <AssignmentScheduledDate date={assignment.to_shoot_at} />
            </div>
            {envVars.VITE_IS_FLOOR_PLAN_ENABLED && assignment.is_3d_scan && (
                <ThreeDScanCard assignment={assignment} variant="scheduled" />
            )}
        </div>
    )
}
